import { render, staticRenderFns } from "./GatCompatibility.vue?vue&type=template&id=74bfe199&scoped=true&"
import script from "./GatCompatibility.vue?vue&type=script&lang=js&"
export * from "./GatCompatibility.vue?vue&type=script&lang=js&"
import style0 from "./GatCompatibility.vue?vue&type=style&index=0&id=74bfe199&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfe199",
  null
  
)

export default component.exports